import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/comp/lib/eventBus.js